import { useEffect, useState } from "react";
import { api, gbp } from "@/lib/api";

const RULES = [
  ["Where we post", "Anywhere in the UK, including Scotland, Wales and Northern Ireland"],
  ["Parcel limits", "Evri parcels up to 15kg — heavier orders are split into more than one parcel"],
];

const BandsTable = ({ meta }) => (
  <div className="mt-6 rounded-2xl bg-white border border-[#EDE4D3] overflow-hidden" data-testid="postage-bands">
    <table className="w-full text-sm">
      <thead className="bg-[#F7F3EB] text-left"><tr><th className="p-4">Parcel weight</th><th className="p-4">Evri Standard (2–4 days)</th></tr></thead>
      <tbody className="divide-y divide-[#EDE4D3]">
        {meta.bands.map((b, i) => (
          <tr key={i}><td className="p-4 font-semibold">Up to {b.max_kg}kg</td><td className="p-4">{gbp(b.standard)}</td></tr>
        ))}
      </tbody>
    </table>
    {meta.free_over != null && <p className="p-4 text-sm bg-[#1B3626] text-white">FREE Evri Standard delivery on orders over {gbp(meta.free_over)}</p>}
  </div>
);

export default function Delivery() {
  const [meta, setMeta] = useState(null);
  useEffect(() => { api.get("/meta").then((r) => setMeta(r.data)); }, []);
  return (
    <div className="max-w-4xl mx-auto px-4 py-16">
      <p className="font-mono text-xs uppercase tracking-[0.25em] text-[#8C2220]">Delivery & stock</p>
      <h1 className="mt-2 font-serif text-4xl sm:text-5xl font-bold">How Albion Pantry works</h1>
      <ol className="mt-10 space-y-6" data-testid="how-it-works">
        {[
          "You place your order and pay securely online.",
          "We visit our local Marks & Spencer, Waitrose, Tesco or Sainsbury's and buy your items.",
          "We pack them carefully and post them to you with Evri.",
          "You get an email with your Evri tracking number.",
        ].map((t, i) => (
          <li key={i} className="flex gap-5 items-start">
            <span className="font-serif text-3xl font-bold text-[#8C2220] w-10 shrink-0 text-center">{i + 1}</span>
            <p className="pt-2 text-slate-700">{t}</p>
          </li>
        ))}
      </ol>
      <h2 className="mt-16 font-serif text-3xl font-bold">Delivery with Evri</h2>
      {meta && <BandsTable meta={meta} />}
      <div className="mt-6 rounded-2xl bg-white border border-[#EDE4D3] divide-y divide-[#EDE4D3]" data-testid="delivery-rules">
        {RULES.map(([k, v]) => (
          <div key={k} className="p-5 grid sm:grid-cols-3 gap-2"><b>{k}</b><span className="sm:col-span-2 text-slate-600">{v}</span></div>
        ))}
      </div>
      <h2 className="mt-16 font-serif text-3xl font-bold">If something's out of stock</h2>
      <div className="mt-6 grid md:grid-cols-2 gap-5" data-testid="stock-policy">
        <div className="rounded-2xl bg-[#F7F3EB] p-6"><p className="font-semibold">Some items unavailable</p><p className="mt-2 text-sm text-slate-600">We send everything that is in stock and refund the missing items to your card straight away.</p></div>
        <div className="rounded-2xl bg-[#1B3626] text-white p-6"><p className="font-semibold">Nothing available</p><p className="mt-2 text-sm text-white/75">We cancel your order and give you a full refund, including delivery.</p></div>
      </div>
    </div>
  );
}
